// extracted by mini-css-extract-plugin
export var boldFontWeight = "700";
export var closeWrapper = "hz_Bw";
export var closeWrapperMobile = "hz_Bx";
export var container = "hz_g";
export var containerIcon = "hz_Bt";
export var containerMobile = "hz_Bv";
export var desktopQuery = "screen and (min-width: 60rem)";
export var extraLargeDesktopQuery = "screen and (min-width: 120rem)";
export var fontFamily = "Neuzeit Grotesk";
export var fontStack = "Neuzeit Grotesk,Helvetica Neue,Helvetica,Arial,sans-serif";
export var harbourBoldFontFamily = "ITC Avant Garde Pro Demi";
export var harbourBoldFontStack = "ITC Avant Garde Pro Demi,sans-serif";
export var harbourBoldFontWeight = "600";
export var harbourRegularFontFamily = "ITC Avant Garde Pro Bk";
export var harbourRegularFontStack = "ITC Avant Garde Pro Bk,sans-serif";
export var harbourRegularFontWeight = "300";
export var headerDesktopQuery = "screen and (min-width: 64rem)";
export var hoverQuery = "(hover: hover)";
export var landscapeQuery = "(orientation: landscape)";
export var largeDesktopQuery = "screen and (min-width: 90rem)";
export var largeTabletQuery = "screen and (min-width: 48rem)";
export var lightFontWeight = "300";
export var link = "hz_Y";
export var maxExtraLargeDesktopScreen = "120rem";
export var maxHeaderMobileScreen = "64rem";
export var maxLargeDesktopScreen = "90rem";
export var maxLargeTabletScreen = "60rem";
export var maxMobileScreen = "30rem";
export var maxSmallTabletScreen = "48rem";
export var maxWideDesktopScreen = "80rem";
export var openCloseWrapper = "hz_Bs";
export var portraitQuery = "(orientation: portrait)";
export var promoMarkdown = "hz_Br";
export var reducedMotionQuery = "(prefers-reduced-motion)";
export var regularFontWeight = "400";
export var removeText = "hz_By";
export var smallTabletQuery = "screen and (min-width: 30rem)";
export var textWrapper = "hz_bs";
export var wideDesktopQuery = "screen and (min-width: 80rem)";
export var wrapper = "hz_C";